import * as React from 'react';
import styles from './Title.module.scss';

import background from '../../assets/img/token-image-sub-page-masthead.svg';
import { Container } from '@mui/material';

export class TitleSmall extends React.Component<{}, {}> {
    public render() {
        return (
            <Container className={styles.titleContainer}>
                <div className={styles.thumbnail}>
                    <img src={background}
                        className={styles.tokenimagehomeMasthead}
                        alt='backround title'
                    />
                </div>
            </Container>
        )
    }
}